import React from 'react'
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { mtFindPerson } from "../api/mtFindPerson";
import { appGlobal } from '../api/appGlobal';
import Steps from "./Steps";
import "./styles.css";
import incode from "./incode";
//importamos useContext
import { useContext } from 'react';
//importamos contexto
import ValidateContext from '../context/context'

//renderizamos tutorial del reverso de la Id
function TutorialFrontId({ token, onSuccess }) {
  const containerRef = useRef();
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      return;
    }
    incode.renderFrontTutorial(containerRef.current, {
      onSuccess,
      noWait: true
    });
    isMounted.current = true;
  }, [onSuccess]);

  return <div ref={containerRef}></div>;
}

//renderizamos camara para captura el reverso de la Id
function DocumentId({ session, onSuccess, showError }) {
  const containerRef = useRef();
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      return;
    }
    incode.renderCamera("document", containerRef.current, {
      onSuccess,
      onError: showError,
      token: session,
      nativeCamera: true,
      numberOfTries: -1
    });
    isMounted.current = true;
  }, [onSuccess, showError, session]);

  return <div ref={containerRef}></div>;
}

//finalizamos sesion de incode y vamos a la panta lla de verifaIdentificacion... si todo sale bien
function FinishSession({ session, navigate, rutaContinue }) {

  const containerRef = useRef();
  let flowId = appGlobal.configurationId;
  let token = session.token;

  React.useEffect(() => {

    async function fbValidarDatos() {

      incode.getFinishStatus(flowId, { token });
      navigate(rutaContinue);

    }
    fbValidarDatos()
  }, []);

  return <div ref={containerRef}></div>;
  
}

export default function AppIncodeDocument({ history }) {

  const location = useLocation();
  const rutaContinue = location.state.rutaContinue;
  const navigate = useNavigate();
  const [session, setSession] = useState();
  const [step, setStep] = useState(1);
  const [error, setError] = useState(false);

  //consumimos el contexto

  //creamos una sesion de incode con un flujo de cliente

  useEffect(() => {

    async function ftnObtenerInterview() {

      const objCons = {
        id: localStorage.getItem('idPerson')
      }

      const response = await mtFindPerson(objCons);

      if (response.status === 200) {
        let flowId = appGlobal.configurationId;
        incode.createSession("ALL", undefined, {
          interviewId: response.interviewIdIne,
        }).then(async (session) => {
          localStorage.setItem("interviewID", session.interviewId)
          setSession(session);
        });
      }

    }

    ftnObtenerInterview();

  }, []);

  function goNext() {
    setStep(step + 1);
  }

  function showError() {
    setError(true);
  }

  window.addEventListener('popstate', function (e) {
    var state = e.state;
    if (state !== null) {
      //load content with ajax
      stopCamera();
      console.log("camara detenida =>");
    }
    else {
      console.log(state);
    }
  });

  function stopCamera() {
    history.go();
  }

  //esta funcion no se usa
  function showExitos() {

    let flowId = appGlobal.configurationId;
    let toke = session.token;

    // history.go();
    incode.getFinishStatus(flowId, { toke });

  }

  if (!session) return "loading";
  if (error) return "Error!";

  //componentes de incode, se les pasa la session como props
  return (
    <>
      <link
        rel="stylesheet"
        href="https://sdk-js.s3.amazonaws.com/sdk/styles-1.6.4.css"
      />
      <Steps currentStep={step}>
        <TutorialFrontId onSuccess={goNext} />
        <DocumentId session={session} onSuccess={goNext} showError={showError} />
        <FinishSession session={session} navigate={navigate} rutaContinue={rutaContinue}/>
      </Steps>
    </>
  );
}
